/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-12-10 09:34:34
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-30 10:24:04
 */
import React from 'react'
import ArrowIcon from '../icons/ArrowIcon'

type TimeSelectorProps = {
  hasValidTime: boolean
  isThisMonth: boolean
  isLastSixMonths: boolean
  startTimeLabel: string
  endTimeLabel: string
  onClick: () => void
  isActive?: boolean
}

const TimeSelector: React.FC<TimeSelectorProps> = ({
  hasValidTime,
  isThisMonth,
  isLastSixMonths,
  startTimeLabel,
  endTimeLabel,
  onClick,
  isActive = false
}) => (
  <div
    className={`pfv2-selector pfv2-selector--time ${
      isActive ? 'pfv2-selector--active' : ''
    }`}
    onClick={onClick}
  >
    <div
      className={`pfv2-selector-value pfv2-selector-value--time ${
        !hasValidTime ? 'pfv2-selector-value--placeholder' : ''
      } ${isActive ? 'pfv2-selector-value--active' : ''}`}
    >
      {hasValidTime ? (
        <>
          {isThisMonth && <span>本月</span>}
          {isLastSixMonths ? (
            <span>过去6个月</span>
          ) : (
            <span>
              {startTimeLabel.includes('.')
                ? `${startTimeLabel}-${endTimeLabel}`
                : `${startTimeLabel}-${endTimeLabel}`}
            </span>
          )}
        </>
      ) : (
        <span>请选择时间</span>
      )}
    </div>
    <ArrowIcon className="pfv2-time-arrow" isActive={isActive} />
  </div>
)

export default TimeSelector
